import {PLANS_WITH_BILLING, PLANS_WITH_BILLING_PLATFORM_PAYMENT, PLANS_WITH_UPGRADE} from 'constants/billing-platform';
import {AccountPlanId} from 'types';

const isUpgradablePlan = (planId: AccountPlanId) => PLANS_WITH_UPGRADE.includes(planId);

const isPlanWithBilling = (planId: AccountPlanId) => PLANS_WITH_BILLING.includes(planId);

const isPlanWithBillingPlatformPayment = (planId: AccountPlanId) => PLANS_WITH_BILLING_PLATFORM_PAYMENT.includes(planId);

export const billingPlatformUtils = {
    isUpgradablePlan,
    isPlanWithBilling,
    isPlanWithBillingPlatformPayment
};
